/* ============================================================================
   Hero promo slider (sections/hero.liquid)
   ----------------------------------------------------------------------------
   Two slides, promo first, cross-fading every `data-seconds`, with arrows and
   dots. The promo slide is only kept inside its window [data-promo-start,
   data-promo-end), checked against the visitor's clock so a page cached before
   the sale still switches it on. ?promo_preview=1 or the theme editor shows it
   regardless.

   Autoplay pauses while the pointer is over the image or a control has focus,
   and after a manual change it restarts the count, so a click is never undone
   a second later. Reduced motion: no autoplay, the controls still work.
   With JS off the promo (first slide) is what shows and the controls do
   nothing; Liquid already drops the promo once the end has passed.
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-hero-slides]').forEach(function (root) {
    var promo = root.querySelector('[data-hero-slide="promo"]');
    var main = root.querySelector('[data-hero-slide="main"]');
    if (!promo || !main) return;

    var controls = root.querySelectorAll('[data-hero-prev], [data-hero-next], .hero__dots');

    var now = Date.now() / 1000;
    var start = parseInt(root.getAttribute('data-promo-start'), 10) || 0;
    var end = parseInt(root.getAttribute('data-promo-end'), 10) || 0;
    var preview = /[?&]promo_preview=1\b/.test(window.location.search) ||
                  root.hasAttribute('data-design-mode');

    if (!preview && (now < start || now >= end)) {
      /* Outside the sale: behave exactly like the plain hero. */
      promo.parentNode.removeChild(promo);
      Array.prototype.forEach.call(controls, function (c) { c.parentNode.removeChild(c); });
      main.classList.add('is-on');
      main.removeAttribute('aria-hidden');
      root.classList.remove('hero__media--slides');
      var pe = document.querySelector('[data-hero-eyebrow-promo]');
      var de = document.querySelector('[data-hero-eyebrow-default]');
      if (pe) pe.parentNode.removeChild(pe);
      if (de) de.hidden = false;
      return;
    }

    var slides = [promo, main];
    var dots = root.querySelectorAll('[data-hero-dot]');
    var i = 0;
    var ms = Math.max(3, parseInt(root.getAttribute('data-seconds'), 10) || 5) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var paused = false;

    function show(n) {
      n = (n + slides.length) % slides.length;
      slides[i].classList.remove('is-on');
      slides[i].setAttribute('aria-hidden', 'true');
      i = n;
      slides[i].classList.add('is-on');
      slides[i].removeAttribute('aria-hidden');
      Array.prototype.forEach.call(dots, function (d, k) {
        d.classList.toggle('is-on', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (reduced || paused || document.hidden) return;
      timer = setInterval(function () { show(i + 1); }, ms);
    }

    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
    if (next) next.addEventListener('click', function () { show(i + 1); play(); });
    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hero-dot'), 10) || 0); play(); });
    });

    /* Swipe on touch screens. */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      show(dx < 0 ? i + 1 : i - 1);
      play();
    });

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; play(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; play(); });

    /* A backgrounded tab piles up nothing useful; restart from the promo. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); return; }
      show(0);
      play();
    });

    play();
  });
})();
